import React from 'react';
import Chart from 'react-apexcharts'

const CHART_COLORS = ['rgb(34, 93, 153)', 'rgb(217, 108, 60)', 'rgb(99, 179, 100)'];

const StackedBarChart = ({ seriesData, categoriesData, title, yaxis_title = '', xaxis_title = '' }) => {
  const options = {
    chart: { type: 'bar', height: 350, stacked: true, toolbar: { show: true } },
    colors: CHART_COLORS,
    title: { text: title, align: 'left', style: { color: 'rgb(30,30,40)', fontWeight: 700 } },
    plotOptions: { bar: { columnWidth: '50%' } },
    xaxis: { categories: categoriesData, title: { text: xaxis_title } },
    yaxis: { title: { text: yaxis_title } },
    legend: { position: 'right' },
    noData: { text: 'No Data Available', style: { color: 'rgb(217, 108, 60)' } },
  }
  return <Chart options={options} series={seriesData} type="bar" height={320} />
}

export default StackedBarChart;